var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meter",class:[_vm.variant, { nostripes: _vm.noStripes }]},[_c('span',{style:({ width: Number(_vm.value) + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }